import React, { useState } from 'react';
import { hot } from 'react-hot-loader';
import { purifier } from '../../utils/dom';
import { translate } from '../../utils/locale';
import { notificationKey, isDismissed } from '../../utils/notification';
import s from './AnnouncementBar.scss';

// The scroller animates by a third of its width, so the items are rendered three times.
const COPIES = [0, 1, 2];

const AnnouncementBar = ({ items, setup }) => {
	const [paused, setPaused] = useState(false);
	const visibleItems = items.filter((item) => !isDismissed(item, setup));
	if (!visibleItems.length) return null;

	const barStyle = visibleItems[0].backgroundColor ? { '--var-background-color': visibleItems[0].backgroundColor } : undefined;

	return (
		<div className={s.announcementBar} role="region" aria-label="Announcement" style={barStyle}>
			<div className={[s.announcementBar_scroller, paused ? s.announcementBar_scroller__paused : null].filter(Boolean).join(' ')}>
				{
					COPIES.map((copy) => visibleItems.map((item) => (
						<div key={`${notificationKey(item)}_${copy}`} className={s.announcementBar_item} style={item.backgroundColor ? { backgroundColor: item.backgroundColor } : undefined} aria-hidden={copy > 0 ? true : undefined} dangerouslySetInnerHTML={{ __html: purifier(translate(setup, item.text), {}, setup) }} />
					)))
				}
			</div>
			<button type="button" className={s.announcementBar_pause} aria-label={paused ? 'Play announcement' : 'Pause announcement'} aria-pressed={paused} onClick={() => setPaused((p) => !p)} />
		</div>
	);
};

export default hot(module)(AnnouncementBar);
